module.exports = __webpack_public_path__ + "assets/images/magazine-gt_712f4653dc8a93afdcb6c792a19aac65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-1/magazine-gt.png
// module id = 279
// module chunks = 0